/**
 * @generated SignedSource<<7f703451722f5224d6ebd6f29d1d06cc>>
 * @relayHash c59725da2182e35bd1314edc8032c545
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cbc50b267ee94c3dad830d0df127567e135d9c254689fe1157c85325974167ac

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssignedQuery$variables = {
  first?: number | null | undefined;
  incomingQuery: string;
  isEnabled: boolean;
  outgoingQuery: string;
  pullRequestQuery: string;
  queryContext: string;
};
export type AssignedQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeAssignedList">;
};
export type AssignedQuery = {
  response: AssignedQuery$data;
  variables: AssignedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "incomingQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "outgoingQuery"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pullRequestQuery"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v6 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v7 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "url"
},
v10 = {
  "kind": "ScalarField",
  "name": "value"
},
v11 = [
  (v10/*: any*/),
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v15 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  {
    "kind": "ScalarField",
    "name": "editDate"
  },
  (v12/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "iconData"
},
v17 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v13/*: any*/),
    (v12/*: any*/)
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v19 = [
  (v12/*: any*/)
],
v20 = [
  {
    "concreteType": "GraphStoreCypherQueryV2Edge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "GraphStoreCypherQueryV2Node",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Column",
            "kind": "LinkedField",
            "name": "columns",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": "goalState",
                                "concreteType": "TownsquareGoalState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v11/*: any*/)
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": "goalCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "goalUpdates",
                                "args": (v14/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v15/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ],
                            "type": "TownsquareGoal"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": "projectState",
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v11/*: any*/)
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": "projectCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "projectUpdates",
                                "args": (v14/*: any*/),
                                "concreteType": "TownsquareProjectUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareProjectUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v15/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ],
                            "type": "TownsquareProject"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "mercuryName"
                                          },
                                          (v12/*: any*/)
                                        ]
                                      },
                                      (v12/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "concreteType": "JiraDateTimePickerField",
                                "kind": "LinkedField",
                                "name": "updatedField",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "dateTime"
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              (v12/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "small"
                                          }
                                        ]
                                      },
                                      (v12/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraProjectField",
                                "kind": "LinkedField",
                                "name": "projectField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v18/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastUpdate"
                              },
                              {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "ThirdPartyUser",
                                    "kind": "LinkedField",
                                    "name": "thirdPartyUser",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "ExternalProvider",
                                "kind": "LinkedField",
                                "name": "provider",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/)
                                ]
                              }
                            ],
                            "type": "ExternalPullRequest"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "AppUser"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "AtlassianAccountUser"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "CustomerUser"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsFeatureFlag"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsOperationsComponentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsOperationsIncidentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsProjectDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsPullRequestDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsRepository"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "DevOpsSecurityVulnerabilityDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "JiraAutodevJob"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "JiraConfluenceRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "JiraCustomRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "JiraIssueRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "JiraWebRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "TeamCustomFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "TeamType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v19/*: any*/),
                            "type": "ThirdPartyUser"
                          }
                        ]
                      },
                      (v12/*: any*/)
                    ],
                    "type": "GraphStoreCypherQueryV2AriNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "type": "GraphStoreCypherQueryV2TimestampObject"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AssignedQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "incomingQuery",
                "variableName": "incomingQuery"
              },
              {
                "kind": "Variable",
                "name": "outgoingQuery",
                "variableName": "outgoingQuery"
              },
              {
                "kind": "Variable",
                "name": "pullRequestQuery",
                "variableName": "pullRequestQuery"
              },
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "HomeAssignedList"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssignedQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "alias": "outgoing",
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "outgoingQuery"
                  },
                  (v7/*: any*/)
                ],
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": (v20/*: any*/)
              },
              {
                "alias": "incoming",
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "incomingQuery"
                  },
                  (v7/*: any*/)
                ],
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": (v20/*: any*/)
              },
              {
                "alias": "pullRequest",
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "pullRequestQuery"
                  },
                  (v7/*: any*/)
                ],
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": (v20/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cbc50b267ee94c3dad830d0df127567e135d9c254689fe1157c85325974167ac",
    "metadata": {},
    "name": "AssignedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dd2a73ee4558c68c836a3edddf268080";

export default node;
